import React, { useState, useEffect, useRef } from "react";
import {SYSTEM_BLUE_BACKGROUND_LIGHT} from "../../../constants/general-constants";

export default function UtilisationTimeline() {
  const [currentTime, setCurrentTime] = useState(0); // Track the current time (for 3s intervals)
  const [timelineData, setTimelineData] = useState([]); // Holds the hour data (weekdays and weekends)
  const timelineRef = useRef(null);

  // Generate two weeks worth of data (336 columns)
  useEffect(() => {
    const data = [];
    let dayOfWeek = 0; // Track the day of the week (0 = Monday, 6 = Sunday)

    for (let i = 0; i < 336; i++) {
      const isWeekend = dayOfWeek === 5 || dayOfWeek === 6; // Saturday/Sunday
      const hour = i % 24;
      const height = getHeightForHour(hour); // Get realistic height for each hour

      data.push({
        hour: hour,
        day: Math.floor(i / 24), // Day index
        isWeekend: isWeekend,
        height: height,
      });

      // Update to next day
      if (i % 24 === 23) {
        dayOfWeek = (dayOfWeek + 1) % 7;
      }
    }
    setTimelineData(data);
  }, []);

  // Function to calculate the height based on the hour of the day
  const getHeightForHour = (hour) => {
    if (hour >= 18 || hour < 6) {
      return 0; // 6 PM to 6 AM - Zero height (low utilization)
    }
    if (hour >= 11 && hour <= 15) {
      return 4; // Peak time: 11 AM to 3 PM - Max height (high utilization)
    }
    return 2; // Other times - Gradual height
  };

  // Move the cursor every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime((prevTime) => (prevTime + 1) % 336); // Loop back to 0 after 336 hours (14 days)
    }, 3000); // Update every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      ref={timelineRef}
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "40px", // Adjust height of the timeline container
        backgroundColor: "black",
        overflowX: "scroll",
        position: "relative",
        alignItems:"bottom"
      }}
    >
      {/* Render columns (bars) */}
      {timelineData.map((data, index) => {
        const isTraversed = index <= currentTime;
        const isWeekend = data.isWeekend;
        const height = isWeekend ? 0 : `${data.height * 10}px`; // Zero height for weekends, scale bars
        
        const backgroundColor = isWeekend
          ? "transparent"
          : isTraversed
          ? SYSTEM_BLUE_BACKGROUND_LIGHT // Turn blue as the cursor passes
          : "white"; // Default white for future hours
				
        return (
          <div
            key={index}
            style={{
              width: "2px",
              height: height,
              backgroundColor: backgroundColor,
              margin: "0 1px",
              //position: "absolute",
              bottom: 0, // Start from the bottom
              transition: "background-color 0.3s", // Smooth transition for colour change
            }}
          />
        );
      })}

      {/* Cursor (Red line) */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: `${(currentTime / 336) * 100}%`, // Calculate cursor position
          width: "2px",
          height: "100%",
          backgroundColor: "red", // Red cursor
        }}
      />
    </div>
  );
}
















